<!-- 设备管理 -->
<template>
  <a-card :bordered="false">
    <a-tabs @change="changeTab">
      <a-tab-pane key="1" :tab="$t('数据列表')">
        <inspectionResults ref="dataList" />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('地图展示')">
        <MapList ref="mapList" />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
  import inspectionResults from './inspectionResults.vue'
  import MapList from './mapList.vue'

  export default {
    name: 'lineList',
    components: {
      inspectionResults,
      MapList
    },
    data () {
      return {
      }
    },
    computed: {
      description() {
        return this.$t('巡检结果页面')
      }
    },
    created() {},
    methods: {
      changeTab(e){
        if(e==2){
          this.$refs.mapList.searchReset();
        }else{
          this.$refs.dataList.searchReset();
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>